export enum EquipmentCategoryListFormValue {
  DESCRIPTION = 'Description',
}
